import { render, staticRenderFns } from "./document-approve.vue?vue&type=template&id=1377f9e9"
import script from "./document-approve.ts?vue&type=script&lang=js&external"
export * from "./document-approve.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports